import { motion, useReducedMotion } from "framer-motion";
import _ from "lodash";
import debounce from "lodash/debounce";
import {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  addByTheHourFormToState,
  addSpecifiedDestinationFormToState,
  getAvailableVehicle,
  getAvailableVehicles,
} from "../../../../actions/admin/booking";
import { getMeetAssistPrice, getSetting } from "../../../../actions/admin/settings";
import LoginModal from "../../../../components/auth/LoginModal";
import Disclaimer from "../../../../components/disclaimer";
import CarSelection from "../../../../components/layout-new-theme/cards/CarSelection";
import VehicleTypeCard from "../../../../components/layout-new-theme/cards/VehicleTypeCard";
import ByTheHourForm from "../../../../components/layout-new-theme/form-card/ByTheHourForm";
import SpecifiedDestinationForm from "../../../../components/layout-new-theme/form-card/SpecifiedDestinationForm";
import Spinner from "../../../../components/layout/Spinner";
import { BackAltIcon } from "../../../../components/icons";
import {
  Reveal,
  Stagger,
  StaggerItem,
  SwapPanel,
  drawLine,
  transitions,
  waitForScrollToSettle,
} from "../../../../components/motion";
import { checkTokenUser, checkTokenUserBusiness } from "../../../../utils/authUtils";
import {
  getKey,
  getTotalLuggageCount,
  getTotalLuggageCountInCabinSize,
  getMaximumLuggageByPax,
  getTotalLuggageCountArray,
  getTotalPaxCount,
  getTotalPaxCountArray,
  getTravelDateWithPickupTime,
} from "../../../../utils/Calculator";
import { cn } from "../../../../utils/classnames";
import moment from "../../../../utils/customMoment";
import { pushEventGTM } from "../../../../utils/gtm";
import { createTypographyHelper } from "../../../../utils/typography";
import GranLuxeHeroVehicle, {
  GRANLUXE_CABIN_IMAGE,
  GRANLUXE_CABIN_SRCSET,
} from "../../_components/GranLuxeHeroVehicle";
import {
  buildDefaultMeetAssistState,
  createMeetAssistPriceStructure,
  getMandatoryMeetAssistDisclaimerKey,
  getPreSelectedMeetAssistTotal,
  getTerminalHint,
  isNightHours,
} from "../../../../utils/meetAssist";
import AlertModal from "./AlertModal";

const newBanner = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/public_folder/cms-image/cms-index/Banner_NEW.jpg";

const Discover = ({
  isEditBooking = false,
  keyBook = "",
}) => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [tabName, setTabName] = useState("byTheHour");
  // 1 when the customer moves to a tab on the right, -1 to the left -- the
  // booking forms slide in from that side.
  const [tabDirection, setTabDirection] = useState(1);
  const shouldReduceMotion = useReducedMotion();
  // The vehicle cards wait until the smooth scroll down to them has landed
  // before they animate in -- doing both at once made the scroll stutter.
  const [hasScrolledToResults, setHasScrolledToResults] = useState(false);
  // Each scroll gets a number, so a quick second search can't be revealed
  // early by the first search's scroll finishing.
  const latestResultsScrollRef = useRef(0);

  const scrollToResults = () => {
    const resultsElement = document.getElementById("scroll01");
    // Not rendered yet on the first search; the showDetailsPannels effect
    // calls this again once it is.
    if (!resultsElement) return;
    const thisResultsScroll = latestResultsScrollRef.current + 1;
    latestResultsScrollRef.current = thisResultsScroll;

    setHasScrolledToResults(false);
    resultsElement.scrollIntoView({ behavior: "smooth" });
    waitForScrollToSettle().then(() => {
      if (latestResultsScrollRef.current === thisResultsScroll) {
        setHasScrolledToResults(true);
      }
    });
  };
  // Coming Back to this page (e.g. "車両の選択画面に戻る" on booking-confirmation)
  // re-runs the vehicle search, so the results are not on the page yet. The
  // browser would still restore the old scroll position, which on the
  // results-less page means sliding down to the footer while the search is
  // running. "manual" tells the browser not to restore this page's position:
  // it stays at the form (with the loading button) and scrollToResults()
  // moves down once the vehicles are shown.
  //
  // The browser stores this setting per history entry, and a page pushed from
  // here copies it — so on leaving, switch the next page back to "auto" to
  // keep the normal Back behaviour everywhere else. ("auto" rather than the
  // value read on mount: after a Back that value is already "manual".)
  useEffect(() => {
    window.history.scrollRestoration = "manual";
    return () => {
      window.history.scrollRestoration = "auto";
    };
  }, []);

  const { byTheHourFormData, specifiedDestinationFormData, cart } = useSelector(
    (state) => state.booking
  );
  const settings = useSelector((state) => state.setting);
  const { setting } = settings;
  const lang = i18n.language?.toUpperCase();
  const [isloading, setIsloading] = useState(false);
  const [vehicleTypeNames, setVehicleTypeNames] = useState([]);
  const [cutomerChangedDropOffTimeOnly, setcutomerChangedDropOffTimeOnly] = useState("");
  const [packageList, setPackageList] = useState([]);
  const [clickedVehicleType, setClickedVehicleType] = useState("");
  const [showDetailsPannels, setShowDetailsPannels] = useState(false);
  const [sfd, setSfd] = useState({
    pickuplocation: null,
    dropofflocations: [],
    traveldate: "",
    pickuptime: "",
    dropofftime: "",
    pax: null,
    flightNo: "",
    isFromAirport: null,
    isToAirport: null,
    isAirportTransfer: null,
    byTheHourBook: false,
    lugage: null,
    flightTracking: null,
    travelArea: null,
  });
  const [cartID, setCartID] = useState(null);
  const [isEquationApplied, setIsEquationApplied] = useState(false);
  const getTypographyClass = createTypographyHelper(i18n.language);

  //state for handle book more than 9 people
  const [bookingInfo, setBookingInfo] = useState([]);
  const [selectedManyVehicleType, setSelectedManyVehicleType] = useState([]);
  const [clickedManyVehicleType, setClickedManyVehicleType] = useState([]);
  const [countCarToChoose, setCountCarToChoose] = useState(1);

  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const [formdatavalidation, setFormdatavalidation] = useState({
    pickuplocation: true,
    dropofflocations: true,
    traveldate: true,
    pickuptime: true,
    pax: true,
    flightNumber: true,
    duration: true,
    luggage: null,
  });

  //new states
  const [startFromGarage, setStartFromGarage] = useState(null);
  const [travelDateWithPickupTime, setTravelDateWithPickupTime] =
    useState(null);
  const [customerDropoffDateTime, setCustomerDropoffDateTime] = useState(null);
  const [garageArrivalTime, setGarageArrivalTime] = useState(null);
  const [totalDistance, setTotalDistance] = useState(0);
  const [garage, setGarage] = useState(null);
  const [additionalTime, setAdditionalTime] = useState(0);
  const [breakTime, setBreakTime] = useState(0);
  const [flightTrackingTime, setFlightTrackingTime] = useState(null);
  const [usageDuration, setUsageDuration] = useState(0);
  const [billedDuration, setBilledDuration] = useState(0);
  const [appliedPackage, setAppliedPackage] = useState(null);

  // Meet & Assist base rates, as configured in the admin dashboard. Fetched
  // once; the night surcharge is applied per search, since it depends on the
  // pickup and dropoff times.
  const [meetAssistRates, setMeetAssistRates] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const loadMeetAssistRates = async () => {
      try {
        const rates = await getMeetAssistPrice();
        if (!cancelled) setMeetAssistRates(rates);
      } catch (error) {
        // Not worth blocking the search over: the cards fall back to the bare
        // vehicle price and the confirmation page fetches the rates again.
        console.error("Failed to load meet & assist pricing:", error);
      }
    };

    loadMeetAssistRates();
    return () => {
      cancelled = true;
    };
  }, []);

  // Both times are stringified the same way into the cart, so the price shown
  // here and the price the confirmation page recalculates agree by construction.
  const meetAssistPrice = useMemo(
    () =>
      createMeetAssistPriceStructure(
        meetAssistRates,
        isNightHours(travelDateWithPickupTime?.toString()),
        isNightHours(customerDropoffDateTime?.toString())
      ),
    [meetAssistRates, travelDateWithPickupTime, customerDropoffDateTime]
  );

  // What the customer is already committed to on this route. Only a Narita
  // pickup puts its pre-selected Meet & Assist into the price on the vehicle
  // cards. The mandatory locations (Haneda T3, Tokyo, Shinjuku) show the
  // charter price only, with a notice under the heading instead; Shinagawa
  // and every dropoff stay out too.
  const preSelectedMeetAssist = useMemo(
    () => ({
      pickupLocation: sfd.pickuplocation,
      dropoffLocation: sfd.dropofflocations?.[sfd.dropofflocations.length - 1],
      hasArrival: Boolean(sfd.isFromAirport || sfd.isFromStation),
      hasDeparture: Boolean(sfd.isToAirport || sfd.isToStation),
      meetAssistPrice,
    }),
    [sfd, meetAssistPrice]
  );

  const preSelectedMeetAssistTotal = useMemo(
    () => getPreSelectedMeetAssistTotal(preSelectedMeetAssist),
    [preSelectedMeetAssist]
  );

  // "Meet & Assist is mandatory here" notice under the Select vehicle heading.
  const mandatoryMeetAssistDisclaimerKey = useMemo(
    () =>
      getMandatoryMeetAssistDisclaimerKey({
        pickupLocation: preSelectedMeetAssist.pickupLocation,
        hasArrival: preSelectedMeetAssist.hasArrival,
        isBusinessUser: checkTokenUserBusiness(),
      }),
    [preSelectedMeetAssist]
  );

  /**
   * * Set the Cart ID when the page is loading. This should only happen IF THE CART IS NOT EMPTY! The Cart ID is used to identify bookings that
   * were made as part of the same purchase/ cart. So, if a cart has 3 bookings in it that are paid together, then they will all share the same cart ID.
   * The cart behaves as a "container" object for the bookings.
   */
  useEffect(() => {
    if (cart?.length === 0 || cart === null) return;
    setCartID(cart[0].randomId);
  }, [cart]);

  /**
   * * Set any active airport transfer packages to the state.
   */
  useEffect(() => {
    if (packageList === null) return;
    if (packageList?.length === 0) return;
  }, [packageList]);

  /**
   * * Reset all the form values to their initial / empty values.
   */
  const resetFormValues = () => {
    setShowDetailsPannels(false);
    setSfd({
      pickuplocation: null,
      dropofflocations: [],
      traveldate: "",
      pickuptime: "",
      dropofftime: "",
      pax: null,
      flightNo: "",
      isToAirport: null,
      isFromAirport: null,
      isAirportTransfer: null,
    });
    setcutomerChangedDropOffTimeOnly("");
  };

  /**
   * * Set the selected tab (By The Hour Destination, Specified Destination) based on which tab was active during the redirect from the
   * home-page (if the booking was started there)
   * ? By The Hour form tab will be selected
   */
  const byTheHourFormAvailableVehicle = (byTheHourFormData) => {
    setTabName("byTheHour");
    setSfd(byTheHourFormData);
    dispatch(addByTheHourFormToState(byTheHourFormData));
    dispatch(addSpecifiedDestinationFormToState(null));
    debouncedCheckAvailability(byTheHourFormData);
    if (isEditBooking) {
      seteditbookingStep(2);
    }
  };

  /**
   * * Set the selected tab (By The Hour Destination, Specified Destination) based on which tab was active during the redirect from the
   * home-page (if the booking was started there)
   * ? Specified Destination form tab will be selected
   */
  const specifiedDestinationFormAvailableVehicle = (
    specifiedDestinationFormData
  ) => {
    setTabName("specifiedDestination");
    setSfd(specifiedDestinationFormData);
    dispatch(addByTheHourFormToState(null));
    dispatch(addSpecifiedDestinationFormToState(specifiedDestinationFormData));
    debouncedCheckAvailability(specifiedDestinationFormData);
    if (isEditBooking) {
      seteditbookingStep(2);
    }
  };

  /**
   * * Set the selected tab (By The Hour, Specified Destination) based on which tab was active during the redirect from the
   * home-page (if the booking was started there)
   * * Set state varibles
   * ? When the parameters change, this funcion will be fired
   * @param byTheHourFormData
   * @param specifiedDestinationFormData
   */
  useEffect(() => {
    if (!settings) dispatch(getSetting());
    if (byTheHourFormData) {
      if (!isEditBooking) {
        byTheHourFormAvailableVehicle(byTheHourFormData);
      }
    } else if (specifiedDestinationFormData) {
      if (!isEditBooking) {
        specifiedDestinationFormAvailableVehicle(specifiedDestinationFormData);
      }
    }
  }, [byTheHourFormData, specifiedDestinationFormData]);

  useEffect(() => {
    if (isEditBooking == false) {
      if (showDetailsPannels) {
        scrollToResults();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showDetailsPannels]);

  /**
   * * This function will be called when the "Search available vehicles" button is clicked by the user
   * * After that, the listed state varibles will be set to their initial vaues
   */
  const availabilityValueReset = () => {
    setShowDetailsPannels(false);
    setPackageList([]);
    setClickedVehicleType(null);
    setVehicleTypeNames([]);
    setBookingInfo([]);
    setSelectedManyVehicleType([]);
    setClickedManyVehicleType([]);
  };

  /**
   * * Main function here. Fire when the "Search available vehicles" button is clicked by the user.
   * ? sfd - Selected Form Data
   * @param sfd
   */
  const debouncedCheckAvailability = useCallback(
    debounce(async (sfd) => {
      setIsloading(true);

      try {
        availabilityValueReset();

        const buffer_time = 1;
        const totalPax = getTotalPaxCount(sfd.pax);

        if (
          !sfd.traveldate ||
          !sfd.pickuptime ||
          !sfd.pickuplocation ||
          sfd.dropofflocations.length === 0 ||
          totalPax === 0
        ) {
          return;
        }

        setVehicleTypeNames([]);

        const { travel_date_with_pickup_time } =
          getTravelDateWithPickupTime(sfd);

        const date_with_buffer_time = moment()
          .tz("Asia/Tokyo")
          .add(buffer_time, "hours");

        if (!travel_date_with_pickup_time.isAfter(date_with_buffer_time)) {
          setFormdatavalidation(prev => ({
            ...prev,
            pickuptime: false,
          }));
          return;
        }

        let reqParamsAvailableVehicle = {
          pickupLocation: sfd.pickuplocation,
          dropoffLocations: sfd.dropofflocations,
          bookingType: sfd.byTheHourBook
            ? "byTheHour"
            : "specifiedDestination",
          travelDate: sfd.traveldate,
          pickupTime: sfd.pickuptime,
          pax: sfd.pax,
          luggage: sfd.lugage,
          isAirportTransfer: sfd.isAirportTransfer,
          isFromAirport: sfd.isFromAirport,
          isToAirport: sfd.isToAirport,
          isStationTransfer: sfd.isStationTransfer,
          isFromStation: sfd.isFromStation,
          isToStation: sfd.isToStation,
        };

        if (sfd.byTheHourBook) {
          reqParamsAvailableVehicle = {
            ...reqParamsAvailableVehicle,
            usageDuration: sfd.duration,
            travelArea: sfd.travelArea,
          };
        }

        const availableVehicle = await getAvailableVehicle(
          reqParamsAvailableVehicle
        );

        /** 🔐 HARD GUARD — must return */
        if (
          !availableVehicle ||
          availableVehicle.code !== 200 ||
          availableVehicle.desc !== "SUCCESS" ||
          !availableVehicle.data
        ) {
          if (availableVehicle?.desc === "INVALID_BOOKING_TIME") {
            setmodalAlertText(
              lang === "EN"
                ? availableVehicle?.error?.EN?.message
                : availableVehicle?.error?.JP?.message
            );
          } else {
            setmodalAlertText(
              availableVehicle?.error ??
              "An error occurred while fetching available vehicles."
            );
          }

          setShowModalAlert(true);
          return;
        }

        /** ✅ SAFE to destructure */
        const {
          startFromGarage,
          travelDateWithPickupTime,
          customerDropoffDateTime,
          garageArrivalTime,
          totalDistance,
          garage,
          additionalTime,
          breakTime,
          flightTrackingTime,
          usageDuration,
          billedDuration,
          appliedPackage,
          availableVehicleTypes,
        } = availableVehicle.data;

        setStartFromGarage(startFromGarage);
        setTravelDateWithPickupTime(travelDateWithPickupTime);
        setCustomerDropoffDateTime(customerDropoffDateTime);
        setGarageArrivalTime(garageArrivalTime);
        setTotalDistance(totalDistance);
        setGarage(garage);
        setAdditionalTime(additionalTime);
        setBreakTime(breakTime);
        setFlightTrackingTime(flightTrackingTime);
        setUsageDuration(usageDuration);
        setBilledDuration(billedDuration);
        setAppliedPackage(appliedPackage);

        if (!availableVehicleTypes || availableVehicleTypes.length === 0) {
          setmodalAlertText(
            "We have no available vehicles on the selected day."
          );
          setShowModalAlert(true);
          return;
        }

        setVehicleTypeNames(
          [...availableVehicleTypes].sort(
            (a, b) => a.baseprice - b.baseprice || a.prioritize - b.prioritize
          )
        );

        setShowDetailsPannels(true);

        scrollToResults();

      } catch (error) {
        console.error("Availability check failed:", error);
        setmodalAlertText("Unexpected error occurred. Please try again.");
        setShowModalAlert(true);
      } finally {
        setIsloading(false);
      }
    }, 500),
    []
  );


  useEffect(() => {
    setFormdatavalidation({
      pickuplocation: true,
      dropofflocations: true,
      traveldate: true,
      pickuptime: true,
      pax: true,
      flightNumber: true,
      duration: true,
      luggage: null,
    });
  }, [tabName]);

  /**
   * * Set the selected tab (Single Destination, Multiple Destination, Airport Transfer, By The Hour) in the UI. Check the tabName parameter value.
   */
  const getTab = () => {
    if (tabName === "byTheHour")
      return (
        <ByTheHourForm
          byTheHourForm={byTheHourFormData}
          checkByTheHourFormAvailableVehicle={byTheHourFormAvailableVehicle}
          availabilityValueReset={availabilityValueReset}
          formValidationData={formdatavalidation}
          isLoading={isloading}
        />
      );
    if (tabName === "specifiedDestination")
      return (
        <SpecifiedDestinationForm
          specifiedDestinationForm={specifiedDestinationFormData}
          checkSpecifiedDestinationFormAvailableVehicle={
            specifiedDestinationFormAvailableVehicle
          }
          cutomerChangedDropOffTimeOnly={cutomerChangedDropOffTimeOnly}
          availabilityValueReset={availabilityValueReset}
          formValidationData={formdatavalidation}
          isLoading={isloading}
        />
      );
  };

  /**
   * * Set equation values and state variables
   * * on click event => when the vehicle type is selected / clicked
   * * hourlyprice = 30 minute rate for the selected vehicle type (this can be specified by the TLF team when creating a vehicle type in the Admin Panel)
   * @param vehicle_type - Selected vehicle type
   */
  const applyToTheEquation = (vehicle_type, index = null) => {
    let newSelectedVehicleType;
    let newClickedManyVehicleType;
    let newBookingInfo;

    if (
      selectedManyVehicleType.length === 0 &&
      selectedManyVehicleType[index] === undefined
    ) {
      newSelectedVehicleType = [...selectedManyVehicleType, vehicle_type];
    } else {
      newSelectedVehicleType = [...selectedManyVehicleType];
      newSelectedVehicleType[index] = vehicle_type;
    }

    setSelectedManyVehicleType(newSelectedVehicleType);

    const totalAmount = vehicle_type.price;

    let childSeatList = [
      {
        childSeatType: "Infant",
        childSeatCount: 0,
      },
      {
        childSeatType: "Toddler",
        childSeatCount: 0,
      },
      {
        childSeatType: "Child",
        childSeatCount: 0,
      },
    ];

    if (
      getTotalPaxCount(sfd.pax) <= 9 &&
      getTotalLuggageCountInCabinSize(sfd.lugage) <= getMaximumLuggageByPax(getTotalPaxCount(sfd.pax))
    ) {
      var paxList = [
        {
          paxtype: "Adult",
          paxcount: sfd.pax.adult,
        },
        {
          paxtype: "Child",
          paxcount: sfd.pax.child,
        },
        {
          paxtype: "Toddler",
          paxcount: sfd.pax.toddler,
        },
        {
          paxtype: "Baby",
          paxcount: sfd.pax.baby,
        },
      ];

      var luggageList = [
        {
          luggagetype: "CHECK-IN SIZE",
          luggagecount: sfd.lugage.checkinSize,
        },
        {
          luggagetype: "CABIN SIZE",
          luggagecount: sfd.lugage.cabinSize,
        },
      ];
      // var paxList = sfd.pax;
      // var luggageList = sfd.lugage;
    } else {
      var paxList = null;
      var luggageList = null;
    }
    // // -------------------------------------------------------------------------------------------------------------------------

    if (selectedManyVehicleType.length === 0 && selectedManyVehicleType[index] === undefined) {
      newClickedManyVehicleType = [...clickedManyVehicleType, vehicle_type.typename]

      newBookingInfo = [...bookingInfo, {
        vehicleTypeName: vehicle_type.typename,
        images: vehicle_type.images,
        vehicleTypeID: vehicle_type._id,
        pax: paxList,
        luggage: luggageList,
        baseprice: vehicle_type.baseprice,
        hourlyprice: vehicle_type.hourlyprice,
        tollFare: vehicle_type.tollFare,
        travelAreaPrice: vehicle_type.travelAreaPrice,
        longDistanceSurcharge: vehicle_type.longDistanceSurcharge,
        total: vehicle_type.price,
        discount: vehicle_type.discount,
        discountedPrice: vehicle_type.discountedPrice,
        childSeat: childSeatList,
        childSeatPrice: 0,
        travelArea: sfd.travelArea,
      }]


      newBookingInfo = [
        ...bookingInfo,
        {
          vehicleTypeName: vehicle_type.typename,
          images: vehicle_type.images,
          vehicleTypeID: vehicle_type._id,
          pax: paxList,
          luggage: luggageList,
          baseprice: vehicle_type.baseprice,
          hourlyprice: vehicle_type.hourlyprice,
          tollFare: vehicle_type.tollFare,
          travelAreaPrice: vehicle_type.travelAreaPrice,
          longDistanceSurcharge: vehicle_type.longDistanceSurcharge,
          total: totalAmount,
          discount: vehicle_type.discount,
          discountedPrice: vehicle_type.discountedPrice,
          childSeat: childSeatList,
          childSeatPrice: 0,
          travelArea: sfd.travelArea,
        },
      ];
    } else {
      newClickedManyVehicleType = [...clickedManyVehicleType];
      newClickedManyVehicleType[index] = vehicle_type.typename;

      newBookingInfo = [...bookingInfo];
      newBookingInfo[index] = {
        vehicleTypeName: vehicle_type.typename,
        images: vehicle_type.images,
        vehicleTypeID: vehicle_type._id,
        pax: paxList,
        luggage: luggageList,
        baseprice: vehicle_type.baseprice,
        hourlyprice: vehicle_type.hourlyprice,
        tollFare: vehicle_type.tollFare,
        travelAreaPrice: vehicle_type.travelAreaPrice,
        longDistanceSurcharge: vehicle_type.longDistanceSurcharge,
        total: vehicle_type.price,
        discount: vehicle_type.discount,
        discountedPrice: vehicle_type.discountedPrice,
        childSeat: childSeatList,
        childSeatPrice: 0,
        travelArea: sfd.travelArea,
      };
    }

    setClickedManyVehicleType(newClickedManyVehicleType);
    setBookingInfo(newBookingInfo);

    if (
      getTotalPaxCount(sfd.pax) <= 9 &&
      getTotalLuggageCountInCabinSize(sfd.lugage) <= getMaximumLuggageByPax(getTotalPaxCount(sfd.pax))
    ) {
      setIsEquationApplied(true);
    }
  };

  const getCurrentMaxPassenger = useMemo(() => {
    const updatedSfd = _.cloneDeep(sfd);
    var bookedPax = updatedSfd.pax;

    if (bookingInfo.length === 0) {
      return bookedPax;
    } else {
      bookingInfo.map((item, index) => {
        if (item !== null) {
          const paxArray = item.pax;
          if (paxArray !== null) {
            bookedPax.adult -= item.pax[0].paxcount;
            bookedPax.child -= item.pax[1].paxcount;
            bookedPax.toddler -= item.pax[2].paxcount;
            bookedPax.baby -= item.pax[3].paxcount;
          }
        }
      });
      return bookedPax;
    }
  }, [bookingInfo]);

  const getCurrentMaxLugage = useMemo(() => {
    const updatedSfd = _.cloneDeep(sfd);

    var bookedLugage = updatedSfd.lugage;

    if (bookingInfo.length === 0) {
      return bookedLugage;
    } else {
      bookingInfo.map((item, index) => {
        if (item !== null) {
          const lugageArray = item.luggage;
          if (lugageArray !== null) {
            bookedLugage.checkinSize -= item.luggage[0].luggagecount;
            bookedLugage.cabinSize -= item.luggage[1].luggagecount;
          }
        }
      });
      return bookedLugage;
    }
  }, [bookingInfo]);

  const getClickedManyVehicleType = useMemo(() => {
    return clickedManyVehicleType;
  }, [clickedManyVehicleType]);

  /**
   * * Set pax values and state variables
   * * on click proceed event => after the vehicle type is selected / clicked
   */
  const applyPaxAndLugageToTheEquation = (pax, lugage, index) => {
    var paxList = [
      {
        paxtype: "Adult",
        paxcount: pax.adult,
      },
      {
        paxtype: "Child",
        paxcount: pax.child,
      },
      {
        paxtype: "Toddler",
        paxcount: pax.toddler,
      },
      {
        paxtype: "Baby",
        paxcount: pax.baby,
      },
    ];

    var luggageList = [
      {
        luggagetype: "CHECK-IN SIZE",
        luggagecount: lugage.checkinSize,
      },
      {
        luggagetype: "CABIN SIZE",
        luggagecount: lugage.cabinSize,
      },
    ];

    // let paxList = pax
    // let luggageList = lugage

    const editedBookingInfo = bookingInfo;

    if (editedBookingInfo[index]) {
      editedBookingInfo[index].pax = paxList;
      editedBookingInfo[index].luggage = luggageList;

      setBookingInfo(editedBookingInfo);

      const totalPax = bookingInfo.reduce(
        (val, item) => val + getTotalPaxCountArray(item.pax),
        0
      );
      const totalLugage = bookingInfo.reduce(
        (val, item) => val + getTotalLuggageCountArray(item.luggage),
        0
      );

      if (
        (totalPax < getTotalPaxCount(sfd.pax)) ||
        (totalLugage < getTotalLuggageCount(sfd.lugage))
      ) {
        if (
          bookingInfo[countCarToChoose - 1] !== undefined &&
          bookingInfo[countCarToChoose - 1].pax !== null
        ) {
          setCountCarToChoose(countCarToChoose + 1);
        }
      } else {
        if (checkTokenUser()) {
          setIsEquationApplied(true);
        } else {
          setShowModal(true);
        }
      }
    }
  };

  useEffect(() => {
    const element = document.getElementById("scroll" + countCarToChoose);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }, [countCarToChoose]);

  useEffect(() => {
    if (isEquationApplied) {
      addTocart(true);
    }
  }, [isEquationApplied]);

  /**
   * * Add item to the cart. Data gets added to the database at this point (if the cart expires with a booking in it, the "isAbandoned" flag gets
   * set to true). Then the booking gets shown in the "Abandoned Carts" view in the Admin Panel (for tracking purposes).
   * @param isCart - bool values. check if true and redirect to the cart page
   */
  const addTocart = async (isCart) => {
    // formValidation();
    const totalPax = getTotalPaxCount(sfd.pax);
    if (
      !sfd.traveldate ||
      !sfd.pickuptime ||
      !sfd.pickuplocation ||
      sfd.dropofflocations.length === 0 ||
      totalPax === 0
    ) {
      setIsloading(false);
    } else {
      // check total time take
      const trip_total_time = Number(bookingInfo[0].totalhours);
      if (trip_total_time / 60 > Number(setting.totaltriptime)) {
        setmodalAlertText(
          "For bookings longer than 16 hours, please contact our sales team."
        );
        setShowModalAlert(true);
        setIsloading(false);
        return;
      }
      setIsloading(true);

      // Checks a vehicle of each requested type is free, and nothing more: the
      // specific vehicle is chosen by an admin on the booking detail page, so
      // this must not write one onto bookingInfo.
      const updatedBookingInfo = [...bookingInfo];

      await Promise.all(
        bookingInfo.map(async (i) => {
          const availableVehicles = await getAvailableVehicles(
            startFromGarage,
            garageArrivalTime,
            i.vehicleTypeName
          );

          if (availableVehicles.length === 0) {
            setmodalAlertText(
              "There are no vehicles available at the selected date and time."
            );
            setShowModalAlert(true);
          }
        })
      );

      setIsloading(false);

      const note_arr = [{ note: "" }];

      // var paxList = [
      //   {
      //     paxtype: "Adult",
      //     paxcount: sfd.pax.adult,
      //   },
      //   {
      //     paxtype: "Child",
      //     paxcount: sfd.pax.child,
      //   },
      //   {
      //     paxtype: "Toddler",
      //     paxcount: sfd.pax.toddler,
      //   },
      //   {
      //     paxtype: "Baby",
      //     paxcount: sfd.pax.baby,
      //   },
      // ];

      // var luggagelist = [
      //   {
      //     luggagetype: "CHECK-IN SIZE",
      //     luggagecount: sfd.lugage.checkinSize,
      //   },
      //   {
      //     luggagetype: "CABIN SIZE",
      //     luggagecount: sfd.lugage.cabinSize,
      //   },
      // ];

      // Seeded from the same pre-selection rules the vehicle cards were priced
      // on. A Haneda pickup is the one exception: it is seeded as selected (so
      // the confirmation page starts on it) but was left out of the card
      // price. The confirmation page re-prices this and lets them change it.
      var meetAssistList = buildDefaultMeetAssistState(preSelectedMeetAssist);

      if (cartID === null) {
        var randomchar =
          Math.floor(Math.random() * 16777215).toString(16) +
          Math.floor(Math.random() * 1000 + 1);
        setCartID(randomchar);
      }

      // Set cart item added time all set to initial added time

      var addedTime = moment();
      if (cart?.length > 0) {
        addedTime = moment(cart[0].date);
      }

      const cart_itm = {
        key: isEditBooking ? keyBook : getKey(),
        travelDate: sfd.traveldate,
        pickupTime: sfd.pickuptime,
        pickupDateTime: travelDateWithPickupTime.toString(),
        customerDropoffDateTime: customerDropoffDateTime.toString(),
        startFromGarage: startFromGarage,
        garageArrivalTime: garageArrivalTime,
        pickupLocation: sfd.pickuplocation,
        destinations: sfd.dropofflocations,
        totalDistance: totalDistance,
        garage: garage,
        paxList: sfd.pax,
        luggagelist: sfd.lugage,
        bookingType: sfd.byTheHourBook ? "byTheHour" : "specifiedDestination",
        additionalTime: additionalTime,
        breakTime: breakTime,
        flightTrackingTime: flightTrackingTime,
        usageDuration: usageDuration,
        billedDuration: billedDuration,
        isAirportTransfer:
          sfd.isAirportTransfer === undefined ? false : sfd.isAirportTransfer,
        isFromAirport:
          sfd.isFromAirport === undefined ? false : sfd.isFromAirport,
        isToAirport: sfd.isToAirport === undefined ? false : sfd.isToAirport,
        isStationTransfer:
          sfd.isStationTransfer === undefined ? false : sfd.isStationTransfer,
        isFromStation:
          sfd.isFromStation === undefined ? false : sfd.isFromStation,
        isToStation: sfd.isToStation === undefined ? false : sfd.isToStation,
        meetAssist: meetAssistList,
        // A customer who searched for a terminal ("haneda terminal 3") starts
        // the booking page on it; they can still change it there.
        pickupTerminal: getTerminalHint(sfd.pickuplocation),
        dropoffTerminal: getTerminalHint(sfd.dropofflocations?.[sfd.dropofflocations.length - 1]),
        isManyPeople: getTotalPaxCount(sfd.pax) > 9 ? true : false,
        package: appliedPackage,
        bookingInfo: updatedBookingInfo,
        date: addedTime,
        passengerPronounced: "Mr.",
        pickupSignHonorific: "Mr.",
        note_arr,
        byTheHourBook: sfd.byTheHourBook,
        duration: sfd.duration,
        travelArea: sfd.travelArea,
        byTheHourPax: sfd.byTheHourPax,
        byTheHourLugage: sfd.byTheHourLugage,
      };

      if (isCart === true) {
        const items = [];

        cart_itm.bookingInfo.map((bi, ind) => {
          const item = {
            index: ind,
            item_id: bi.vehicleTypeID,
            item_name: bi.vehicleTypeName,
            item_brand: "Toyota",
            affiliation: "Flywire",
            coupon: "",
            discount: 0,
            item_category:
              cart_itm.bookingType === "byTheHour"
                ? "By The Hour"
                : cart_itm.isAirportTransfer
                  ? "Airport Transfer"
                  : "Specified Destination",
            item_category2:
              cart_itm.destinations.length === 1
                ? cart_itm.destinations[0].place_id
                : cart_itm.destinations[cart_itm.destinations.length - 1]
                  .place_id,
            price: bi.total,
            quantity: 1,
          };

          items.push(item);
        });

        const ecommerceData = {
          items: items,
        };

        pushEventGTM({
          event: "select_item",
          ecommerce: ecommerceData,
        });

        if (!isEditBooking) {
          history.push("/booking-confirmation", {
            cart_item: JSON.stringify(cart_itm),
          });
        } else {
          history.push("/booking-confirmation", {
            cart_item: JSON.stringify(cart_itm),
            isEditBooking: true,
            keyBook: keyBook,
          });
        }
      } else {
        window.location.reload(false);
      }
    }
  };

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [modalAlertText, setmodalAlertText] = useState("");

  const handleOpenModalAlert = (item) => {
    setShowModalAlert(true);
  };

  const handleCloseModalAlert = () => {
    setShowModalAlert(false);
  };

  const [editbookingStep, seteditbookingStep] = useState(1);

  const bookTabs = [
    { name: "byTheHour", label: t("ByTheHour.Destinations.Mobile") },
    { name: "specifiedDestination", label: t("Specified.Destinations") },
  ];

  // Same tab behaviour as the home page hero.
  const selectTab = (name) => {
    if (name === tabName) return;
    const fromIndex = bookTabs.findIndex((tab) => tab.name === tabName);
    const toIndex = bookTabs.findIndex((tab) => tab.name === name);
    setTabDirection(toIndex > fromIndex ? 1 : -1);
    setTabName(name);
  };

  const wellCabinDetailPath = `/${i18n.language}/fleet-types?type=ToyotaAlphardWELLCabin`;
  const wellCabinTitle = t("FleetTypePage.ToyotaAlphardWELLCabin.Title");
  const wellCabinViewDetails = t(
    "FleetTypePage.ToyotaAlphardWELLCabin.HeroBanner.ViewDetails"
  );

  return (
    <>
      <AlertModal
        handleClose={handleCloseModalAlert}
        show={showModalAlert}
        text={modalAlertText}
      />
      {!isEditBooking ? (
        <div className="tw:relative tw:h-screen tw:md:h-auto">
          <div className="tw:hidden tw:md:block">
            {/* Aspect ratio is pinned to the retired banner's 1440x666 so the
                headline and booking form keep their percentage offsets. */}
            <GranLuxeHeroVehicle
              src={GRANLUXE_CABIN_IMAGE}
              srcSet={GRANLUXE_CABIN_SRCSET}
              sizes="(min-width: 1920px) 960px, 50vw"
              alt={wellCabinTitle}
              to={wellCabinDetailPath}
              cta={wellCabinViewDetails}
              parallax
              delay={0.1}
              className="tw:w-full tw:aspect-[1440/666]"
              vehicleClassName="tw:left-[2%] tw:top-[10%] tw:w-[50%]"
            />
          </div>
          <div className="tw:hidden tw:md:block tw:md:absolute tw:z-10 tw:bottom-[20%] tw:w-[40%] tw:left-[76px] tw:cursor-pointer tw:max-w-[1920px]">
            <Reveal
              onMount
              y={28}
              duration={0.8}
              delay={0.15}
              className="tw:font-libre-caslon-display tw:text-white tw:text-[30px] tw:md:text-[45px] tw:leading-[40px] tw:md:leading-[58px]"
            >
              {t("Book.Your.Journey")}
            </Reveal>
          </div>
          <div
            className={`tw:w-full tw:md:absolute tw:md:z-[40] tw:top-[180px] tw:md:top-[10%] tw:md:left-[50%] tw:md:-translate-x-[50%] tw:md:px-[76px] tw:md:bg-none tw:max-w-[1920px] tw:m-auto tw:pointer-events-none`}
          >
            <div className="tw:absolute tw:md:hidden tw:w-full tw:pointer-events-auto">
              {/* Same 262px band the mobile banner used to occupy, above the form. */}
              <GranLuxeHeroVehicle
                src={GRANLUXE_CABIN_IMAGE}
                srcSet={GRANLUXE_CABIN_SRCSET}
                alt={wellCabinTitle}
                to={wellCabinDetailPath}
                enterFrom={-24}
                delay={0.05}
                className="tw:w-full tw:h-[262px]"
                vehicleClassName="tw:left-0 tw:top-[-2%] tw:w-full"
              >
                {/* Same left-hand scrim the old mobile banner had, so the
                    headline stays legible where it crosses the vehicle. */}
                <div
                  aria-hidden="true"
                  className="tw:pointer-events-none tw:absolute tw:inset-0 tw:bg-[linear-gradient(90deg,rgba(10,11,13,0.95)_0%,rgba(10,11,13,0.82)_30%,rgba(10,11,13,0.55)_62%,rgba(10,11,13,0)_92%)]"
                ></div>
              </GranLuxeHeroVehicle>
            </div>
            <div className="tw:relative tw:z-10 tw:pt-[120px] tw:md:hidden tw:pointer-events-none">
              <Reveal
                onMount
                y={20}
                duration={0.7}
                delay={0.1}
                className="tw:font-libre-caslon-display tw:text-white tw:px-[30px] tw:text-[30px] tw:leading-[40px] tw:pb-7 tw:pointer-events-auto"
              >
                {t("Book.Your.Journey")}
              </Reveal>
            </div>
            <div id="booking-form-section" className="tw:relative tw:z-10 tw:grid tw:grid-cols-2 tw:pb-5 tw:md:pb-0">
              <div className="tw:hidden tw:2xl:block tw:2xl:w-[644px]"></div>
              <div className="tw:col-span-2 tw:md:col-span-1 tw:md:col-end-3 tw:pointer-events-auto">
                <Reveal
                  onMount
                  y={22}
                  duration={0.7}
                  delay={0.3}
                  className="tw:md:max-w-[625px] tw:md:ml-auto"
                >
                  {/* <!-- select tab btns --> */}
                  <div className="tw:flex tw:justify-between tw:items-end tw:w-full tw:border-b-4 tw:border-b-[#333333]">
                    {bookTabs.map((tab) => {
                      const isActiveTab = tab.name === tabName;
                      return (
                        <div
                          key={tab.name}
                          className={cn(
                            "tw:relative tw:flex-1 tw:rounded-t-[5px] tw:flex tw:items-center tw:justify-center tw:text-center tw:cursor-pointer",
                            isActiveTab
                              ? cn(
                                "tw:text-white tw:h-[74px]",
                                getTypographyClass(14),
                                getTypographyClass(14, "md")
                              )
                              : cn(
                                "tw:h-[59px] tw:text-[#A7A7A7] tw:bg-[#282828]",
                                getTypographyClass(12),
                                getTypographyClass(13, "md")
                              )
                          )}
                          onClick={() => selectTab(tab.name)}
                        >
                          {/* One shared background that slides and resizes
                              between the tabs, as on the home page. */}
                          {isActiveTab && (
                            <motion.span
                              layoutId="booking-tab-highlight"
                              className="tw:absolute tw:inset-0 tw:bg-[#333333]"
                              style={{ borderRadius: "5px 5px 0 0" }}
                              transition={shouldReduceMotion ? { duration: 0 } : transitions.spring}
                            />
                          )}
                          <span className="tw:relative tw:z-[1]">{tab.label}</span>
                        </div>
                      );
                    })}
                  </div>
                  {/* <!-- hero form part --> */}
                  {/* The old form slides out as the new one slides in, and the
                      height eases between them so the page below doesn't jump. */}
                  <SwapPanel activeKey={tabName} direction={tabDirection}>
                    {getTab()}
                  </SwapPanel>
                </Reveal>
                {/* <!-- hero form part end --> */}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow">
            <div className="tw:flex tw:mb-6 tw:items-center">
              {editbookingStep == 2 && (
                <BackAltIcon className="tw:mr-4" aria-label="Back Icon" role="img" />
              )}
              <p className="fs-22 noto tw:m-0">
                {editbookingStep == 1 ? "Edit Booking" : "Select Vehicle"}
              </p>
            </div>
            {editbookingStep == 1 && (
              <ul className="tw:flex tw:flex-wrap tw:pl-0 tw:mb-0 tw:list-none nav-custom tw:md:flex-row tw:text-center">
                <li className={`tw:md:py-0 tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none`}>
                  <div
                    className={`tw:block tw:px-4 tw:py-2 tw:no-underline nav-link-form tw:lg:px-12 tw:flex tw:justify-center tw:items-center ${tabName === "byTheHour" ? "active" : ""
                      }`}
                    onClick={() => {
                      resetFormValues();
                      setTabName("byTheHour");
                    }}
                    role={"button"}
                  >
                    <span className="tw:hidden tw:md:block">
                      {t("ByTheHour.Destinations.Mobile")}
                    </span>
                    <span className="tw:block tw:md:hidden">
                      {t("ByTheHour.Destinations.Mobile")}
                    </span>
                  </div>
                </li>
                <li className={`tw:md:py-0 tw:px-[calc(var(--gx)/2)] tw:w-1/2 tw:flex-none`}>
                  <div
                    className={`tw:block tw:px-4 tw:py-2 tw:no-underline nav-link-form tw:lg:px-12 tw:flex tw:justify-center tw:items-center ${tabName === "specifiedDestination" ? "active" : ""
                      }`}
                    onClick={() => {
                      resetFormValues();
                      setTabName("specifiedDestination");
                    }}
                    role={"button"}
                  >
                    {t("Specified.Destinations")}
                  </div>
                </li>
              </ul>
            )}
          </div>

          {/* <!-- form part --> */}
          {editbookingStep == 1 && getTab()}
        </>
      )}

      {/* </LoadingOverlay> */}
      {/* <!-- section 2 end --> */}

      {editbookingStep == 2 && !showDetailsPannels && (
        <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:text-center">
          <Spinner />
        </div>
      )}
      {showDetailsPannels && (
        <Fragment>
          <div
            className={`tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:px-[calc(var(--gx)/2)] ${!isEditBooking && "py-5"} tw:px-0`}
            id="scroll01"
          >
            {!isEditBooking && (
              // The two rules draw in towards the title as the results appear.
              <Stagger
                onMount
                stagger={0.08}
                className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:items-center tw:!mx-0"
              >
                <StaggerItem
                  variants={drawLine()}
                  className="tw:flex-1 tw:basis-0 tw:grow tw:px-0 tw:origin-right"
                >
                  <hr className="tw:!border-0 tw:!border-b tw:!border-b-[#D9D9D9]" />
                </StaggerItem>
                <StaggerItem y={16} className="tw:px-[calc(var(--gx)/2)] tw:w-auto tw:flex-none tw:text-center">
                  <div className="tw:font-libre-caslon-display tw:text-[26px] tw:md:!text-[34px] tw:px-7 tw:md:px-[42px] tw:capitalize">
                    {t("Discover.Heading.Three")}
                  </div>
                </StaggerItem>
                <StaggerItem
                  variants={drawLine()}
                  className="tw:flex-1 tw:basis-0 tw:grow tw:px-0 tw:origin-left"
                >
                  <hr className="tw:!border-0 tw:!border-b tw:!border-b-[#D9D9D9]" />
                </StaggerItem>
              </Stagger>
            )}
            {!isEditBooking && mandatoryMeetAssistDisclaimerKey && (
              <Reveal
                onMount
                as="p"
                y={10}
                delay={0.25}
                className={cn(
                  "tw:text-center tw:text-[#4E4E4E]! tw:mb-0 tw:px-4",
                  getTypographyClass(13),
                  getTypographyClass(14, "md")
                )}
              >
                {t(mandatoryMeetAssistDisclaimerKey)}
              </Reveal>
            )}
            {/* <!-- section 1 select vehicle --> */}
            {getTotalPaxCount(sfd.pax) <= 9 && getTotalLuggageCountInCabinSize(sfd.lugage) <= getMaximumLuggageByPax(getTotalPaxCount(sfd.pax)) ? (
              <>
                {/* <!-- select vehicle heading end --> */}
                <div
                  className={`${!isEditBooking && "container px-md-3 mt-4 mt-lg-3 pt-lg-5"}`}
                >
                  {packageList.length > 0 && (
                    <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:items-center tw:justify-center">
                      <div className="tw:px-[calc(var(--gx)/2)] tw:flex-1 tw:basis-0 tw:grow">
                        <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]">
                          <div
                            className="tw:flex-1 tw:p-4 bg-gold-light-100 tw:border tw:border-[#dee2e6] tw:border-0"
                            style={{ padding: "0.5rem" }}
                          >
                            <p className="tw:mb-0 tw:font-light! tw:text-center">
                              {lang == "EN"
                                ? `${packageList[0].packagename} is applied`
                                : `「${packageList[0].packagenameJP}」 のパッケージに該当します`}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Cards rise in one after another once the scroll down to
                      them has landed (edit mode doesn't scroll, so it shows
                      them straight away); hovering one lifts it slightly.
                      Each wrapper is the grid cell, and the card fills it
                      (h-full), so equal row heights are kept. */}
                  <Stagger
                    onMount
                    animate={isEditBooking || hasScrolledToResults ? "visible" : "hidden"}
                    stagger={0.06}
                    className="tw:grid tw:grid-cols-1 tw:lg:grid-cols-2 tw:2xl:grid-cols-3 tw:md:[grid-auto-rows:1fr] tw:gap-x-4 tw:gap-y-4 tw:md:gap-y-[22px]"
                  >
                    {vehicleTypeNames.map((vt, i) => (
                      <StaggerItem
                        key={vt._id}
                        y={16}
                        className="tw:h-full"
                        whileHover={shouldReduceMotion ? undefined : { y: -4, transition: transitions.fast }}
                      >
                        <VehicleTypeCard
                          index={i}
                          onClick={(vehicle_type) => {
                            // check auth
                            setClickedVehicleType(vehicle_type);
                            if (checkTokenUser()) {
                              applyToTheEquation(vehicle_type);
                            } else {
                              if (isEditBooking) {
                                applyToTheEquation(vehicle_type);
                              } else {
                                setShowModal(true);
                              }
                            }
                          }}
                          vehicle_type={vt}
                          useModal={true}
                          price={vt.discount?.amount > 0 ? vt.discountedPrice : vt.price}
                          meetAssistPrice={preSelectedMeetAssistTotal}
                          isEditBooking={isEditBooking}
                        />
                      </StaggerItem>
                    ))}
                  </Stagger>
                  <LoginModal
                    show={showModal}
                    useAfterLoginFunc={true}
                    handleAfterLogin={() => {
                      setShowModal(false);
                      applyToTheEquation(clickedVehicleType);
                    }}
                    handleCloseModal={handleCloseModal}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:items-center tw:justify-center">
                  <div className="tw:px-[calc(var(--gx)/2)] tw:md:w-2/3 tw:md:flex-none tw:text-center tw:justify-center tw:pl-4 tw:pt-4 tw:pb-2 tw:mx-auto">
                    {
                      (lang === "EN" || lang === "en") ? (
                        <p>
                          Due to vehicle capacity limitations
                          (a maximum of&nbsp;
                          <b className="text-background-highlight">
                            9 passengers
                          </b>&nbsp;
                          per vehicle),&nbsp;
                          <b className="text-background-highlight">
                            2 vehicles
                          </b>&nbsp;
                          will be required to accommodate your group.
                        </p>
                      ) : (
                        <p>
                          車両の定員制限（1台あたり最大
                          <b className="text-background-highlight">
                            9名
                          </b>
                          ）により、
                          <b className="text-background-highlight">
                            2台
                          </b>
                          のご予約が必要となります。
                        </p>
                      )
                    }
                  </div>
                </div>
                {/* <!-- select vehicle heading end --> */}

                {packageList.length > 0 && (
                  <div className="tw:flex tw:flex-wrap tw:[--gx:1.5rem] tw:mx-[calc(var(--gx)/-2)] tw:mb-4 tw:items-center tw:justify-center">
                    <div className="tw:px-[calc(var(--gx)/2)] tw:w-[83.3333%] tw:flex-none">
                      <div className="tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]">
                        <div
                          className="tw:flex-1 tw:p-4 bg-gold-light-100 tw:border tw:border-[#dee2e6] tw:border-0"
                          style={{ padding: "0.5rem" }}
                        >
                          <p className="tw:mb-0 tw:font-light! tw:text-center">
                            {packageList[0].packagename} is applied
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {Array.from({ length: countCarToChoose }, (_, index) => (
                  <CarSelection
                    key={index}
                    index={index}
                    vehicleTypeNames={vehicleTypeNames}
                    applyToTheEquation={applyToTheEquation}
                    applyPaxAndLugageToTheEquation={
                      applyPaxAndLugageToTheEquation
                    }
                    idScroll={"scroll" + (index + 1)}
                    currentMaxPassenger={getCurrentMaxPassenger}
                    currentMaxLugage={getCurrentMaxLugage}
                    clickedManyVehicleType={getClickedManyVehicleType}
                    meetAssistPrice={preSelectedMeetAssistTotal}
                  />
                ))}
                <LoginModal
                  show={showModal}
                  useAfterLoginFunc={true}
                  handleAfterLogin={() => {
                    setShowModal(false);
                    setIsEquationApplied(true);
                  }}
                  handleCloseModal={handleCloseModal}
                />
              </>
            )}
            {/* <!-- section 1 end --> */}
            <div className="tw:w-full tw:mx-auto tw:[--gx:1.5rem] tw:sm:max-w-[540px] tw:md:max-w-[720px] tw:lg:max-w-[960px] tw:xl:max-w-[1140px] tw:2xl:max-w-[1320px] tw:md:px-4 tw:mt-6 tw:lg:mt-4 tw:lg:pt-2">
              <Reveal y={16} className="bg-gold-grey-F9F9F9 tw:p-6 tw:mt-4 tw:rounded-[0.5rem]">
                <div
                  className="tw:overflow-auto custom-scrollbar"
                  style={{ height: "auto" }}
                >
                  <Disclaimer
                    textClassName={'tw:!text-[14px] tw:!text-[#4E4E4E] tw:!text-[400]'}
                    p4ClassName={'tw:!mb-0'}
                    withTitle={true}
                  />
                </div>
              </Reveal>
            </div>
          </div>
        </Fragment>
      )}
    </>
  );
};

export default Discover;
